export default __webpack_public_path__ + "633dd2b.png";